import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { map, mergeMap, shareReplay, tap } from 'rxjs/operators';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root',
})
export class PolicyService extends BaseService {
    public policyReview = new Subject();

    public loaded: boolean = false;

    public registers: any;

    public policyAccepted: boolean;

    constructor(private router: Router, private http: HttpClient) {
        super();
    }

    getPrivacyPolicy() {
        const body = this.setBody();
        return this.http.post(this.urlService + this.routeAdress.route_privacy_get, body.toString()).pipe(
            tap((response: any) => {
                if (!response.registers) return response;
                this.registers = response.registers[0];
                this.policyAccepted = response.tokenParameter.policyReview < 2;
                return response;
            })
        );
    }

    setPrivacyPolicy() {
        const body = this.setBody();
        body.set('accept', 1);
        return this.http.post(this.urlService + this.routeAdress.route_privacy_set, body.toString()).pipe(
            tap((response: any) => {
                this.policyAccepted = response.tokenParameter.policyReview < 2;
                this.policyReview.next(response.tokenParameter.policyReview);
                return response;
            })
        );
    }

    async getContent() {
        return await this.getPrivacyPolicy()
            .pipe(map((response: any) => response.registers))
            .toPromise();
    }

    getPolicyAccepted() {
        return this.policyAccepted
            ? of(this.policyAccepted)
            : this.getPrivacyPolicy().pipe(
                  mergeMap((response: any) => {
                      if (response.tokenParameter.policyReview === 2) {
                          return of(this.router.createUrlTree(['/policy-review']));
                      } else {
                          return of(true);
                      }
                  })
              );
    }

    hasUser() {
        return !!this.localStorage.getUser();
    }
}
